import { OneInternalSdk } from '@one/sdk-internal/build/main'
import Vue from 'vue'

// @ts-ignore
Vue.use(OneInternalSdk)
